module.exports = "/images/fj.svg?25cc27217d4ae4092e7ffce8ab726fee";